<template>
  <!-- <v-card max-width="400" class="pa-2 flex-grow-1" hover link> -->
  <!-- <v-card-text class="pt-0"> -->
  <v-row class="mt-2 mb-0" no-gutters>
    <!-- <v-chip color="primary" class="text-h6 mr-0 ml-auto"> -->
    <span style="font-weight:700">
      {{ ruleType.Name }}
    </span>
    &nbsp;
    {{
      ` - ${$t(
        "components.plan_benefit_rules.rule_type_help_tile.this_rule_uses_the_following_parameters"
      )}: ${parametersNames()}. Usage example: ${usageExample()}`
    }}
    <!-- </v-chip>
      </v-row>
      <v-row class="mt-0">
        <v-col>
          {{$t("components.plan_benefit_rules.rule_type_help_tile.this_rule_uses_the_following_parameters")}}
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col
          cols="12"S
          sm="12"
          class="ma-0 pa-0"
          v-for="parameter in ruleType.Parameters"
          :key="parameter.Name"
        >
          {{ `${parameter.Name} (${parameter.Type})` }} 
        </v-col>-->
  </v-row>
  <!-- </v-card-text>
  </v-card> -->
</template>

<script>
export default {
  props: [
    "ruleType",
    "plans",
    // "healthBenefitCategories",
    // "dentalBenefitCategories",
  ],
  methods: {
    parametersNames() {
      return this.ruleType.Parameters.map((o) => `${o.Name} (${this.$t(o.Type)})`);
    },
    usageExample() {
      return `${this.ruleType.Name}(${this.ruleType.Parameters.map(
        (o) => `${o.Name}:${this.exampleValueFromType(o.Type)}`
      ).join(", ")})`;
    },
    exampleValueFromType(type) {
      switch (type) {
        case "System.Int32": {
          return "123";
        }
        case "System.Decimal": {
          return "123.45";
        }
        default: {
          return "asd";
        }
      }
    },
  },
};
</script>

<style></style>
